"use strict";
export const CSRF_HEADER = "X-CSRF-Token";
export function csrfToken() {
  var _a;
  const meta = (_a = document.head) == null ? void 0 : _a.querySelector(
    'meta[name="csrf-token"]'
  );
  return meta && meta.content !== "" ? meta.content : null;
}
